/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { traitStakingContract } from "config";
import { useContractWrite, useWaitForTransaction } from "wagmi";
import useSnackbarRpcError from "hooks/useSnackbarRpcError";
import useCaptureRpcException from "hooks/useCaptureRpcException";
import useSnackbarRpcSuccess from "hooks/useSnackbarRpcSuccess";

const useUnstakeTraits = (
  tokenId: number,
  categories: string[],
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data, loading: isLoading, error: writeError }, unstake] =
    useContractWrite(
      {
        addressOrName: traitStakingContract.address,
        contractInterface: traitStakingContract.interface,
      },
      "unstakeTraits",
      {
        args: [tokenId, categories],
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction({
      confirmations: 1,
      wait: data?.wait,
    });

  useSnackbarRpcError(writeError);
  useSnackbarRpcError(waitError);
  useSnackbarRpcSuccess(waitData);

  useCaptureRpcException(waitError);
  useCaptureRpcException(writeError);

  useEffect(() => {
    if (!isWaiting && waitData) {
      onSuccess?.();
    }
  }, [isWaiting, waitData]);

  return [unstake, isLoading || isWaiting];
};

export default useUnstakeTraits;
